import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { client } from '../api/client'
import './FlagsPanel.css'
const labels={password:'密码框',comment:'HTML注释',console:'控制台',network:'网络请求',localstorage:'Local Storage',cookie:'Cookie',media:'移动端视图',sourcetxt:'源码文件'}
export default function FlagsPanel() {
  const {user}=useSelector(state=>state.user)
  const [flags,setFlags]=useState([]), [progress,setProgress]=useState([])
  const [input,setInput]=useState(''), [message,setMessage]=useState(''), [busy,setBusy]=useState(false)
  const refresh=async()=>{
    const [r,p]=await Promise.all([client.get('/flags'),client.get('/api/progress')])
    setFlags(r.data.sort((a,b)=>b.flags-a.flags));setProgress(p.data.completed)
  }
  useEffect(()=>{refresh().catch(e=>setMessage(String(e)));const t=setInterval(()=>refresh().catch(e=>setMessage(String(e))),3000);return()=>clearInterval(t)},[])
  const submit=async e=>{
    e.preventDefault();setBusy(true)
    try { const {data}=await client.post('/flag',{flag:input});setMessage(data.msg);setInput('');await refresh() }
    catch(e){setMessage(String(e))} finally {setBusy(false)}
  }
  return <div className="flags-container">
    <form className="flags-submit-container" onSubmit={submit}>
      <span>{user.team}战队 · {user.name}</span>
      <input aria-label="flag" className="flag-input" value={input} placeholder="输入/粘贴flag到这里并提交" onChange={e=>setInput(e.target.value)}/>
      <button className="flag-submit-btn" disabled={busy||!input.trim()}>提交</button>
    </form>
    <p role="status">{message}</p>
    <div style={{maxHeight:160,overflow:'auto'}}>{progress.map(p=><p key={p.kind}>{labels[p.kind]}：{p.name}（{p.sid}） · {new Date(p.submittedAt).toLocaleString()}</p>)}</div>
    <div className="flags-rank-container">{flags.map((f,i)=><div className="team-cell" key={f.team}><span>第{i+1}名</span><span>{f.team}战队（{f.dorm}）</span><span>得分:{f.flags}</span></div>)}</div>
  </div>
}
